module.exports = __webpack_public_path__ + "static/media/privacy_all_enterprise.19ca6c5c.svg";